import React from 'react'
import { Badge } from 'react-bootstrap'

interface InvoiceFilterBadgeProps {
	text: string
	amount: number
	handleClick: (filter: string) => void
	selected: boolean
}

const InvoiceFilterBadge = (props: InvoiceFilterBadgeProps) => {
	return (
		<Badge pill onClick={() => props.handleClick(props.text.toLowerCase().replace(/ /g, '-'))} className={props.selected ? 'selected' : ''}>
			{props.text}
			<Badge pill bg="secondary">
				{props.amount}
			</Badge>
		</Badge>
	)
}

export { InvoiceFilterBadge }
